export enum RequestTypeEnum {
  BASE_PROSPECTUS = 'BASE_PROSPECTUS',
  STANDALONE_PROSPECTUS = 'STANDALONE_PROSPECTUS',
  TRIPARTITE_BASE_PROSPECTUS = 'TRIPARTITE_BASE_PROSPECTUS',
  TRIPARTITE_PROSPECTUS_2D = 'TRIPARTITE_PROSPECTUS_2D',
  TRIPARTITE_PROSPECTUS_3D = 'TRIPARTITE_PROSPECTUS_3D',
  SUPPLEMENT = 'SUPPLEMENT',
  REGISTRATION_DOCUMENT = 'REGISTRATION_DOCUMENT',
  UNIVERSAL_REGISTRATION_DOCUMENT = 'UNIVERSAL_REGISTRATION_DOCUMENT',
}
